import { render, staticRenderFns } from "./PLIOdontologos.vue?vue&type=template&id=c0e8558e&scoped=true&"
import script from "./PLIOdontologos.vue?vue&type=script&lang=js&"
export * from "./PLIOdontologos.vue?vue&type=script&lang=js&"
import style0 from "./PLIOdontologos.vue?vue&type=style&index=0&id=c0e8558e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e8558e",
  null
  
)

export default component.exports